import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { VznLoginComponent } from '@noammazuz/vzn-login';
import { AuthService } from '@noammazuz/vzn-feathers';
import { appState } from '@services/app-state';

import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { AppStateService } from '@servicesapp-state.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent implements OnInit {
  showLogin: boolean;
  appState = appState;
  form: FormGroup;
  loginState = 'email';

  constructor(
    public authService: AuthService<any>,
    private router: Router,
    private formBuilder: FormBuilder,
    public translate: TranslateService,
    private appStateService: AppStateService
  ) {
    this.translate=translate;
    this.form = this.formBuilder.group({
      phoneNumber: [''],
      verificationCode: [''],
    });
  }

  async ngOnInit() {
  }

  async authSuccess(e) {
    this.translate.reloadLang('he');
    this.translate.reloadLang('en');

    this.appStateService.authSuccess();
    this.router.navigate(['/sites']);
  }

  get loginStateChangeText() {
    return this.loginState === 'email' ? this.translate.instant('MAIN-APP.LOGIN-WITH-PHONE') : this.translate.instant('MAIN-APP.LOGIN-WITH-EMAIL') ;
  }

  toggleLoginState() {
      switch (this.loginState) {
          case 'email': {
              this.loginState = 'phone';
              break;
          }
          case 'phone': {
            this.loginState = 'email';
            break;
        }
      }
  }
}
